import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/lib/auth";
import { ThemeProvider } from "@/lib/theme";
import Login from "@/pages/Login";
import Landing from "@/pages/Landing";
import AdminDashboard from "@/pages/AdminDashboard";
import ThreadDetail from "@/pages/ThreadDetail";
import Agents from "@/pages/Agents";
import WebhookSettings from "@/pages/WebhookSettings";
import AgentDashboard from "@/pages/AgentDashboard";
import TaskDetail from "@/pages/TaskDetail";
import KarmaTasks from "@/pages/KarmaTasks";
import TelegramSettings from "@/pages/TelegramSettings";
import Subreddits from "@/pages/Subreddits";
import Orchestrate from "@/pages/Orchestrate";
import AgentDetail from "@/pages/AgentDetail";
import Products from "@/pages/Products";
import Competitors from "@/pages/Competitors";
import Campaigns from "@/pages/Campaigns";
import DriftCampaigns from "@/pages/DriftCampaigns";
import Training from "@/pages/Training";
import AISettings from "@/pages/AISettings";
import AwarenessMixes from "@/pages/AwarenessMixes";
import AgentGroups from "@/pages/AgentGroups";
import Broadcast from "@/pages/Broadcast";
import Reassignments from "@/pages/Reassignments";
import "@/App.css";

function Protected({ children, role }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="p-8 text-zinc-500 font-mono text-sm">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (role && user.role !== role) return <Navigate to={user.role === "admin" ? "/admin" : "/agent"} replace />;
  return children;
}

function RoleHome() {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (!user) return <Landing />;
  return <Navigate to={user.role === "admin" ? "/admin" : "/agent"} replace />;
}

export default function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <div className="App min-h-screen bg-[var(--bg)] text-[var(--text-primary)]">
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/" element={<RoleHome />} />

          <Route path="/admin" element={<Protected role="admin"><AdminDashboard /></Protected>} />
          <Route path="/admin/orchestrate" element={<Protected role="admin"><Orchestrate /></Protected>} />
          <Route path="/admin/campaigns" element={<Protected role="admin"><Campaigns /></Protected>} />
          <Route path="/admin/drift" element={<Protected role="admin"><DriftCampaigns /></Protected>} />
          <Route path="/admin/training" element={<Protected role="admin"><Training /></Protected>} />
          <Route path="/admin/ai-settings" element={<Protected role="admin"><AISettings /></Protected>} />
          <Route path="/admin/mixes" element={<Protected role="admin"><AwarenessMixes /></Protected>} />
          <Route path="/admin/subreddits" element={<Protected role="admin"><Subreddits /></Protected>} />
          <Route path="/admin/products" element={<Protected role="admin"><Products /></Protected>} />
          <Route path="/admin/competitors" element={<Protected role="admin"><Competitors /></Protected>} />
          <Route path="/admin/threads/:id" element={<Protected role="admin"><ThreadDetail /></Protected>} />
          <Route path="/admin/agents" element={<Protected role="admin"><Agents /></Protected>} />
          <Route path="/admin/agents/:id" element={<Protected role="admin"><AgentDetail /></Protected>} />
          <Route path="/admin/agent-groups" element={<Protected role="admin"><AgentGroups /></Protected>} />
          <Route path="/admin/broadcast" element={<Protected role="admin"><Broadcast /></Protected>} />
          <Route path="/admin/reassignments" element={<Protected role="admin"><Reassignments /></Protected>} />
          <Route path="/admin/webhook" element={<Protected role="admin"><WebhookSettings /></Protected>} />

          <Route path="/agent" element={<Protected><AgentDashboard /></Protected>} />
          <Route path="/agent/tasks/:id" element={<Protected><TaskDetail /></Protected>} />
          <Route path="/agent/karma" element={<Protected><KarmaTasks /></Protected>} />
          <Route path="/agent/profile" element={<Protected><AgentDetail /></Protected>} />
          <Route path="/telegram" element={<Protected><TelegramSettings /></Protected>} />

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </div>
    </AuthProvider>
    </ThemeProvider>
  );
}
